var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "FormFieldsContainer",
        { attrs: { titulo: "Selección Formato Informe" } },
        [
          _c(
            "v-flex",
            [
              _c(
                "v-radio-group",
                {
                  attrs: { row: "", disabled: _vm.accion === 3 },
                  model: {
                    value: _vm.formFields.formato.value,
                    callback: function($$v) {
                      _vm.$set(_vm.formFields.formato, "value", $$v)
                    },
                    expression: "formFields.formato.value"
                  }
                },
                [
                  _c("v-radio", { attrs: { label: "PDF", value: 1 } }),
                  _c("v-radio", { attrs: { label: "Excel", value: 2 } }),
                  _c("v-radio", { attrs: { label: "CSV", value: 3 } })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }